export default {
  version: 'master',
  compilation: '229796'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1472
// module chunks = 22